import { generalTranslations } from "../general.js";

export default generalTranslations;
